export const DeleteTidbitActionTypes = {
  DELETE_TIDBIT_LOADING: "DELETE_TIDBIT_LOADING",
  DELETE_TIDBIT_ERROR: "DELETE_TIDBIT_ERROR",
  DELETE_TIDBIT_SUCCESS: "DELETE_TIDBIT_SUCCESS",
};
